import cx from 'classnames'
import type { ComponentType } from 'react'

import {
  Container,
  type Space,
  type BackgroundColor,
  type ContainerProps,
} from '@/legacy/components/Container'

type ContainerInputsFromBuilder = {
  id?: string
  space?: Space
  spaceIn?: Space
  background?: BackgroundColor
  backgroundColor?: string
  position?: 'left' | 'center' | 'right'
}

type WithContainerProps<T> = T & ContainerInputsFromBuilder

export function withContainer<T>(
  Component: ComponentType<T>,
  directlyPassedFromComponentProps?: ContainerProps,
) {
  return function WithContainer(propsFromBuilder: WithContainerProps<T>) {
    const containerProps = extractContainerProps(propsFromBuilder, directlyPassedFromComponentProps)
    return (
      <Container {...containerProps}>
        <Component {...propsFromBuilder} />
      </Container>
    )
  }
}

const DEFAULT_PROPS = {
  backgroundColor: 'snow',
  spaceOut: '0',
  spaceIn: '0',
  maxWidth: 'md',
} as const

function extractContainerProps<T>(
  propsFromBuilder: WithContainerProps<T>,
  directlyPassedContainerProps?: ContainerProps,
) {
  return {
    backgroundColor:
      propsFromBuilder.background ||
      directlyPassedContainerProps?.backgroundColor ||
      DEFAULT_PROPS.backgroundColor,
    backgroundColorHex:
      propsFromBuilder.backgroundColor || directlyPassedContainerProps?.backgroundColorHex,
    contentClassName: directlyPassedContainerProps?.contentClassName,
    spaceOut:
      propsFromBuilder.space || directlyPassedContainerProps?.spaceOut || DEFAULT_PROPS.spaceOut,
    spaceIn:
      propsFromBuilder.spaceIn || directlyPassedContainerProps?.spaceIn || DEFAULT_PROPS.spaceIn,
    maxWidth: directlyPassedContainerProps?.maxWidth || DEFAULT_PROPS.maxWidth,
    className: cx(
      { [`et-ta-${propsFromBuilder.position}`]: propsFromBuilder.position },
      directlyPassedContainerProps?.className,
    ),
    id: propsFromBuilder.id || directlyPassedContainerProps?.id,
  }
}
